<template>
  <div class="flavor" v-if="locale.logs">

    <template v-if="loaded == false">
      <div class="spinner">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
      </div>
    </template>

    <template v-if="loaded == true">
      <div class="logs">
        <div class="content-headline">
          <div class="content-headline__wrapper">
            <h1>{{locale.logs.logs}}</h1>
          </div>
        </div>
        <div class="select-wrapper select-wrapper--limited-width">
          <select class="select" v-model="hitsPerPage" v-on:change="loaded = false; getLogs(page)">
            <option v-bind:key="option" v-for="option in selectableHitsPerPage" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="table-responsive logs__table">
          <table class="responsive">
            <thead>
            <tr>
              <th scope="col">{{locale.logs.date}}</th>
              <th scope="col">{{locale.logs.cid}}</th>
              <th scope="col">{{locale.logs.type}}</th>
              <th scope="col">{{locale.logs.serverity}}</th>
              <th scope="col">{{locale.logs.message}}</th>
            </tr>
            </thead>
            <tbody>
              <template v-for="log in logs['hits']['hits'] ">
                <tr v-bind:key="log['date']">
                  <td data-label="Date">{{log['_source']['date']}}</td>
                  <td data-label="Cid">{{log['_source']['cid']}}</td>
                  <td data-label="Type">{{log['_source']['type']}}</td>
                  <td data-label="Serverity">{{log['_source']['serverity']}}</td>
                  <td data-label="Message">{{log['_source']['message']}}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <template v-for="n in totalPages">
            <template v-if="n == page">
              <a v-bind:key="n" href="#" class="active" v-on:click="setPageTo(n)">{{n}}</a>
            </template>
            <template v-else>
              <a v-bind:key="n" href="#" v-on:click="setPageTo(n)">{{n}}</a>
            </template>
          </template>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '../api/openstack'

export default {
  name: 'Logs',
  computed: mapState([
    'locale'
  ]),
  data: function () {
    return {
      interval: null,
      page: 1,
      logs: [],
      totalPages: 0,
      hitsPerPage: 20,
      selectableHitsPerPage: [10, 20, 30, 50, 100, 200],
      loaded: false
    }
  },
  created () {
    this.getLogs(this.page)
    this.interval = setInterval(function () {
      this.getLogs(this.page)
    }.bind(this), 3000)
  },
  methods: {
    getLogs (page) {
      api.logs.getLogs(page, this.hitsPerPage).then((response) => {
        this.logs = response.data
        this.loaded = true
        this.totalPages = Math.ceil(this.logs['hits']['total'] / this.hitsPerPage)
      }).catch((error) => {
        console.log(error)
      })
    },
    setPageTo (newPage) {
      this.loaded = false
      this.page = newPage
      this.getLogs(newPage)
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Logs.vue